import * as React from "react";
import classnames from 'classnames';

const Content = (props: {
    aside?: boolean,
    className?: string,
    children?: React.ReactNode
}) => (
    <div className={classnames("ll-main-content", {"ll-main-content-aside": props.aside === true}, props.className)}>
        {props.children}
    </div>
);

export default Content;